/* Testimonials: Swiper carousel with the competitor's exact config —
   infinite loop (cloned slides repeat endlessly), centered slides,
   3.5-up desktop / 2-up tablet / 1.3-up mobile. */
(function () {
  var init = function () {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('[data-pawable-testimonials]:not([data-init])').forEach(function (el) {
      el.setAttribute('data-init', '');
      var section = el.closest('.pawable-testimonials');
      new Swiper(el, {
        speed: 300,
        spaceBetween: 20,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: section.querySelector('[data-pawable-testimonials-next]'),
          prevEl: section.querySelector('[data-pawable-testimonials-prev]'),
        },
        pagination: {
          el: section.querySelector('[data-pawable-testimonials-pagination]'),
          type: 'bullets',
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        },
        breakpoints: {
          320: { spaceBetween: 20, slidesPerView: 1.3 },
          768: { spaceBetween: 20, slidesPerView: 2 },
          1024: { spaceBetween: 28, slidesPerView: 3.5 },
        },
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
